module.exports = __webpack_public_path__ + "img/capability-slider-img-3.a2e67757.png";